import React from 'react';

const INK = '#776958';
const WOOD = '#ba936d';
const DARK_WOOD = '#947355';
const PAPER = '#f7efdb';
const PALETTES = [
  { main: '#90a78d', pale: '#d9e3cb', second: '#d6a783', warm: '#ead3a7' },
  { main: '#8ca7b4', pale: '#d4e3e7', second: '#bd9eac', warm: '#e9dbca' },
  { main: '#ba9386', pale: '#eddbd1', second: '#9aab8b', warm: '#e7d5a9' },
  { main: '#aca0b7', pale: '#e3dbe9', second: '#d5ad75', warm: '#f1e5cd' },
];

function Desk() {
  return <g>
    <path d="m54 137-5 46h12l8-46m183 0 8 46h12l-5-46" fill={DARK_WOOD} />
    <path d="M43 121h233l10 17H33z" fill="#d8b48a" stroke={DARK_WOOD} strokeWidth="2.5" />
    <rect x="33" y="135" width="253" height="10" rx="4" fill={WOOD} />
    <path d="M46 138h226" stroke="#e1c49f" strokeWidth="2" />
  </g>;
}

function Paper({ x, y, width = 49, height = 62, angle = 0, color = PAPER, children }) {
  return <g transform={`translate(${x} ${y}) rotate(${angle})`}>
    <rect x="2" y="3" width={width} height={height} rx="3" fill={INK} opacity=".08" />
    <rect width={width} height={height} rx="3" fill={color} stroke="#c4b398" strokeWidth="1.5" />
    <path d={`M8 13h${width - 16}M8 22h${width - 16}M8 31h${width - 20}M8 40h${width - 22}`} stroke="#c5b99f" strokeWidth="1.8" />
    {children}
  </g>;
}

function Book({ x, y, width = 60, color, angle = 0 }) {
  return <g transform={`translate(${x} ${y}) rotate(${angle})`}>
    <rect width={width} height="16" rx="3" fill={color} stroke={INK} strokeWidth="1.5" />
    <path d={`M9 3h${width - 12}v10H9z`} fill={PAPER} />
    <path d={`M13 6h${width - 21}m-${width - 21} 4h${width - 21}`} stroke="#d1c2a7" strokeWidth="1.1" />
  </g>;
}

function OpenBook({ x = 108, y = 91, width = 104, color }) {
  return <g transform={`translate(${x} ${y}) scale(${width / 104})`}>
    <path d="M0 5c17-8 36-5 52 3 16-8 35-11 52-3v38c-17-8-36-5-52 2-16-7-35-10-52-2z" fill={color} stroke={INK} strokeWidth="2" />
    <path d="M4 1c16-6 33-2 48 5 15-7 32-11 48-5v35c-16-6-34-3-48 3-14-6-32-9-48-3z" fill={PAPER} stroke="#c5b79f" strokeWidth="1.4" />
    <path d="M52 6v32M12 12l28 3m-28 6 28 3m-28 6 28 3m24-18 28-3m-28 12 28-3m-28 12 28-3" stroke="#c6b89c" strokeWidth="1.7" />
  </g>;
}

function Cup({ x, y, color, scale = 1 }) {
  return <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <path d="M10-8c17-2 17 15 0 15" stroke={INK} strokeWidth="3" />
    <path d="M-13-10h26l-2 21c-7 5-15 5-22 0z" fill={color} stroke={INK} strokeWidth="2" />
    <ellipse cy="-10" rx="13" ry="4" fill={PAPER} stroke={INK} strokeWidth="2" />
    <ellipse cy="-10" rx="9" ry="2" fill="#ae9475" />
  </g>;
}

function Board({ x = 64, y = 35, width = 178, height = 92, color = PAPER, children }) {
  return <g transform={`translate(${x} ${y})`}>
    <path d={`M19 ${height}l-9 54m${width - 28}-${54} 9 54`} stroke={DARK_WOOD} strokeWidth="6" />
    <rect width={width} height={height} rx="5" fill={color} stroke={DARK_WOOD} strokeWidth="5" />
    <path d={`M-7 ${height + 3}h${width + 14}`} stroke={WOOD} strokeWidth="7" />
    {children}
  </g>;
}

function Clock({ x, y, color, size = 25 }) {
  return <g transform={`translate(${x} ${y}) scale(${size / 25})`}>
    <circle r="25" fill={color} stroke={INK} strokeWidth="3" />
    <circle r="20" fill={PAPER} />
    <path d="M0-15v3M15 0h-3M0 15v-3M-15 0h3M0-10V0l8 5" stroke={INK} strokeWidth="2.5" />
    <circle r="2.5" fill={INK} />
  </g>;
}

function Calculator({ x, y, p, angle = 0 }) {
  return <g transform={`translate(${x} ${y}) rotate(${angle})`}>
    <rect width="53" height="70" rx="6" fill={p.main} stroke={INK} strokeWidth="2.5" />
    <rect x="7" y="8" width="39" height="16" rx="2" fill={p.pale} stroke={INK} strokeWidth="1.5" />
    <path d="M30 13h10m-7 5h7" stroke={INK} strokeWidth="2" />
    {[0, 1, 2].map((row) => [0, 1, 2].map((col) => <rect key={`${row}-${col}`} x={8 + col * 14} y={32 + row * 11} width="9" height="7" rx="2" fill={row === 2 && col === 2 ? p.second : PAPER} />))}
  </g>;
}

function Globe({ x, y, p, size = 40 }) {
  return <g transform={`translate(${x} ${y}) scale(${size / 40})`}>
    <path d="M-10 44h33M7 43V30M-19-35C-58 5-10 57 28 20" stroke={INK} strokeWidth="4" />
    <circle r="34" fill={p.pale} stroke={INK} strokeWidth="2.5" />
    <path d="m-20-23 11 3 5 10 15-1 9 14-13 9-2 16-10 4-6-15-14-6 3-12-9-8zM19-26l10 12-7 8-9-9z" fill={p.main} />
    <path d="M-31 7c22 7 40 4 62-8M-10-32C-23-8-16 16 4 34M8-33C26-12 26 9 13 31" stroke="#8fa4a1" strokeWidth="1.5" opacity=".65" />
    <path d="m-21-35-6-7m56 63 7 5" stroke={INK} strokeWidth="4" />
  </g>;
}

function Box({ x, y, width = 64, height = 45, color }) {
  return <g transform={`translate(${x} ${y})`}>
    <path d={`M0 8h${width}v${height}H0zM0 8l12-8h${width - 1}l-11 8M${width} 8l11-8v${height}l-11 8`} fill={color} stroke={INK} strokeWidth="2" />
    <path d={`M${width / 2 - 7} 8h14v15h-14z`} fill={PAPER} opacity=".7" />
    <rect x="10" y={height - 8} width="23" height="8" rx="1.5" fill={PAPER} />
  </g>;
}

function Sales({ p }) {
  return <g>
    <Board x={45} y={35} width={142} height={106} color={p.pale}>
      <circle cx="39" cy="32" r="15" fill={p.main} /><path d="M19 65c0-23 40-23 40 0" fill={p.main} />
      <path d="M78 25h42M78 40h30M78 55h38M21 83h99" stroke={INK} strokeWidth="3" />
    </Board>
    <path d="M187 155h99v29h-99z" fill={WOOD} stroke={DARK_WOOD} strokeWidth="2.5" />
    <path d="m197 141 69-7 6 30-69 7z" fill={PAPER} stroke={INK} strokeWidth="2" />
    <circle cx="214" cy="151" r="6" fill={p.second} /><path d="m229 148 27-3m-26 10 23-2" stroke={p.main} strokeWidth="3" />
    <path d="m201 159 72-4 1 12-72 5z" fill={p.pale} stroke={INK} strokeWidth="1.6" />
  </g>;
}

function Counselor({ p }) {
  return <g>
    <Desk /><Clock x={233} y={87} color={p.main} size={33} />
    <OpenBook x={82} y={84} width={108} color={p.main} />
    <path d="m132 122 40-33" stroke={INK} strokeWidth="4" />
    <path d="M47 93h29v31H47zM44 89h35v8H44z" fill={p.second} stroke={INK} strokeWidth="2" />
    <path d="m53 90-4-20 17 7 5 13" fill={PAPER} stroke="#c6b89c" strokeWidth="1.5" />
    <path d="M111 58c-21-21-44-3-30 12l15 11 4-12c16 4 24-4 11-11" fill={p.pale} stroke={INK} strokeWidth="2" />
  </g>;
}

function Pr({ p }) {
  return <g>
    <Board x={161} y={30} width={115} height={111} color={p.pale}>
      <rect x="12" y="13" width="90" height="51" rx="3" fill={PAPER} /><circle cx="74" cy="30" r="10" fill={p.second} />
      <path d="m16 59 24-24 19 16 15-9 25 17" fill={p.main} />
      <path d="M15 79h84m-84 14h60" stroke={INK} strokeWidth="3" />
    </Board>
    <path d="M79 115v48m0-3-31 23m31-23 33 23" stroke={INK} strokeWidth="6" />
    <rect x="34" y="67" width="92" height="58" rx="10" fill={p.main} stroke={INK} strokeWidth="3" />
    <path d="m48 67 8-14h29l7 14" fill={p.pale} stroke={INK} strokeWidth="2.5" />
    <circle cx="83" cy="96" r="23" fill={PAPER} stroke={INK} strokeWidth="3" /><circle cx="83" cy="96" r="16" fill={p.pale} stroke={INK} strokeWidth="2" /><circle cx="80" cy="92" r="7" fill={p.main} />
    <rect x="41" y="76" width="15" height="8" rx="2" fill={p.warm} />
  </g>;
}

function Hotel({ p }) {
  return <g>
    <path d="M44 130h232v53H44z" fill={p.main} stroke={INK} strokeWidth="2.5" /><path d="M55 142h210v31H55z" fill={p.pale} />
    <rect x="36" y="119" width="249" height="15" rx="4" fill={WOOD} stroke={DARK_WOOD} strokeWidth="2.5" />
    <rect x="58" y="28" width="113" height="88" rx="5" fill={DARK_WOOD} stroke={INK} strokeWidth="2.5" />
    {[0, 1].map((row) => [0, 1, 2].map((col) => <g key={`${row}-${col}`} transform={`translate(${68 + col * 33} ${38 + row * 36})`}><rect width="27" height="29" rx="2" fill={p.pale} /><circle cx="12" cy="11" r="4" stroke={INK} strokeWidth="2" /><path d="M12 15v8m0-3h5" stroke={INK} strokeWidth="2" /></g>))}
    <ellipse cx="232" cy="116" rx="34" ry="6" fill={INK} opacity=".15" />
    <path d="M206 110c1-35 50-35 51 0z" fill={p.warm} stroke={INK} strokeWidth="2.5" /><path d="M202 111h59v9h-59z" fill={p.second} stroke={INK} strokeWidth="2" />
    <path d="M232 83V72m-7-1h14" stroke={INK} strokeWidth="4" />
  </g>;
}

function Activist({ p }) {
  return <g>
    <path d="M111 100v84" stroke={DARK_WOOD} strokeWidth="9" />
    <rect x="41" y="36" width="140" height="81" rx="6" fill={p.pale} stroke={DARK_WOOD} strokeWidth="4" />
    <path d="M74 63h76M74 77h61M74 91h70" stroke={p.main} strokeWidth="6" /><circle cx="59" cy="63" r="4" fill={p.second} /><circle cx="59" cy="78" r="4" fill={p.second} /><circle cx="59" cy="92" r="4" fill={p.second} />
    <path d="m180 179 22-82h54l21 82z" fill={WOOD} stroke={DARK_WOOD} strokeWidth="3" />
    <Paper x={208} y={81} width={49} height={66} angle={5} color={p.pale} /><Paper x={193} y={86} width={49} height={66} angle={-5} />
    <path d="m194 143 64 2 7 15h-76z" fill={p.main} stroke={INK} strokeWidth="2" />
  </g>;
}

function Writer({ p }) {
  return <g>
    <Desk /><Book x={45} y={108} width={59} color={p.main} angle={-3} /><Book x={48} y={94} width={58} color={p.second} angle={2} />
    <Paper x={111} y={55} width={62} height={71} angle={-7} /><Paper x={136} y={59} width={63} height={71} angle={3} />
    <path d="m185 116 40-61 9 6-41 61-14 8z" fill={p.main} stroke={INK} strokeWidth="2" /><path d="m185 116 8 6-14 8z" fill={PAPER} /><path d="m179 130 3-7 4 3z" fill={INK} />
    <path d="m225 55 4-6c4-5 13 1 9 7l-4 5" fill={p.second} stroke={INK} strokeWidth="2" />
    <Cup x={258} y={108} color={p.pale} scale={.8} /><rect x="213" y="106" width="21" height="20" rx="4" fill={p.main} stroke={INK} strokeWidth="2" /><rect x="218" y="100" width="12" height="7" rx="2" fill={INK} />
  </g>;
}

function Chef({ p }) {
  return <g>
    <path d="M42 130h237v53H42z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="M52 142h62v33H52zm75 0h62v33h-62zm75 0h65v33h-65z" fill={p.main} opacity=".55" />
    <rect x="34" y="117" width="253" height="17" rx="3" fill={WOOD} stroke={DARK_WOOD} strokeWidth="2.5" />
    <path d="M74 70h74v36c-2 16-72 16-74 0z" fill={p.main} stroke={INK} strokeWidth="3" /><path d="M74 80H61v20h13m74-20h13v20h-13" stroke={INK} strokeWidth="4" />
    <path d="M69 70c14-19 70-19 84 0z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="M101 54v-6h20v6" stroke={INK} strokeWidth="3" />
    <rect x="184" y="99" width="78" height="19" rx="7" fill="#d4ad7c" stroke={DARK_WOOD} strokeWidth="2" /><path d="m191 106 29-24 9 11-31 18" fill={PAPER} stroke={INK} strokeWidth="2" /><path d="m220 82 12-11 8 9-11 13" fill={p.second} stroke={INK} strokeWidth="2" />
    <circle cx="246" cy="100" r="10" fill={p.second} stroke={INK} strokeWidth="2" /><path d="m240 92 6 4 6-5m-6 5v-10" stroke={p.main} strokeWidth="2" />
  </g>;
}

function Designer({ p }) {
  return <g>
    <Desk /><Paper x={153} y={37} width={87} height={90} angle={3}><path d="m15 67 23-39 23 39zm24-23 25 18" stroke={p.main} strokeWidth="3" /><circle cx="65" cy="19" r="10" fill={p.second} /></Paper>
    <g transform="translate(62 78) rotate(-16)"><rect width="37" height="53" rx="4" fill={p.main} stroke={INK} strokeWidth="2" /><path d="M6 8h25v17H6z" fill={p.pale} /><circle cx="18" cy="43" r="3" fill={PAPER} /></g>
    <g transform="translate(84 77) rotate(-1)"><rect width="37" height="53" rx="4" fill={p.second} stroke={INK} strokeWidth="2" /><path d="M6 8h25v17H6z" fill={p.warm} /><circle cx="18" cy="43" r="3" fill={PAPER} /></g>
    <g transform="translate(109 79) rotate(15)"><rect width="37" height="53" rx="4" fill={p.pale} stroke={INK} strokeWidth="2" /><path d="M6 8h25v17H6z" fill={p.main} /><circle cx="18" cy="43" r="3" fill={PAPER} /></g>
    <path d="m242 122 26-61 7 3-25 61-9 5z" fill={p.second} stroke={INK} strokeWidth="2" />
  </g>;
}

function Musician({ p }) {
  return <g>
    <path d="M97 174v-27m0 27-25 12m25-12 26 12" stroke={DARK_WOOD} strokeWidth="5" />
    <path d="M96 177c-36 0-51-33-33-55 6-7 16-11 15-21 0-14 35-14 35 0-1 10 9 14 15 21 18 22 4 55-32 55" fill="#d8ad78" stroke={INK} strokeWidth="3" />
    <path d="m86 100 5-64h12l6 64" fill={DARK_WOOD} stroke={INK} strokeWidth="2" /><path d="m88 37-2-19 21-1 2 20z" fill={p.main} stroke={INK} strokeWidth="2" /><path d="M87 22h-7m7 9h-7m29-9h7m-7 9h7" stroke={INK} strokeWidth="3" />
    <circle cx="97" cy="123" r="15" fill="#8c7056" stroke="#efcf9f" strokeWidth="4" /><path d="M84 151h27" stroke={DARK_WOOD} strokeWidth="7" /><path d="M94 25v127m3-127v127m3-127v127" stroke={PAPER} strokeWidth=".9" />
    <path d="M224 128v49m0-1-31 11m31-11 31 11" stroke={INK} strokeWidth="5" /><path d="M181 62h84l9 67h-100z" fill={p.main} stroke={INK} strokeWidth="2.5" />
    <Paper x={188} y={56} width={70} height={63} angle={2} /><path d="M196 82h51m-51 7h51m-51 7h51m-51 7h51M209 74v27c-12-4-12 8-3 8 5 0 6-4 6-8V75l20-5v26c-12-3-11 8-3 8 5 0 6-4 6-8V67" stroke={INK} strokeWidth="1.7" />
  </g>;
}

function Developer({ p }) {
  return <g>
    <Desk /><rect x="164" y="34" width="105" height="73" rx="5" fill={INK} stroke={INK} strokeWidth="3" /><rect x="170" y="40" width="93" height="59" rx="2" fill={p.pale} />
    <path d="m191 55-9 10 9 10m49-20 9 10-9 10m-25-24-8 29" stroke={p.main} strokeWidth="4" /><path d="M216 107v15m-22 0h43" stroke={INK} strokeWidth="6" />
    <rect x="51" y="68" width="108" height="57" rx="5" fill={p.main} stroke={INK} strokeWidth="2.5" /><rect x="57" y="74" width="96" height="43" rx="2" fill={PAPER} /><path d="M65 84h28m7 0h22m-57 9h52m-44 9h45" stroke={p.main} strokeWidth="3" />
    <path d="M48 124h114l13 10H35z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="M87 127h34l3 4H84z" fill={p.main} /><Cup x={277} y={110} color={p.second} scale={.65} />
  </g>;
}

function Owner({ p }) {
  return <g>
    <path d="M43 52h107v129H43z" fill={p.pale} stroke={DARK_WOOD} strokeWidth="3" /><path d="M43 92h107m-107 44h107" stroke={WOOD} strokeWidth="6" />
    <Box x={53} y={62} width={34} height={22} color={p.second} /><Box x={96} y={61} width={33} height={23} color={p.main} />
    <path d="M59 105h22v28H59zm37 0h25v28H96z" fill={p.main} stroke={INK} strokeWidth="2" /><path d="M63 99h14v7H63zm38 0h15v7h-15z" fill={p.second} stroke={INK} strokeWidth="1.5" />
    <path d="M175 127h109v56H175z" fill={p.main} stroke={INK} strokeWidth="2.5" /><path d="M167 118h125v16H167z" fill={WOOD} stroke={DARK_WOOD} strokeWidth="2.5" />
    <path d="m194 117 9-33h48l11 33z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><rect x="209" y="68" width="39" height="29" rx="4" fill={p.main} stroke={INK} strokeWidth="2.5" /><path d="M215 74h27v15h-27z" fill={PAPER} />
    <path d="M207 106h43m-34 9h26M183 148h90" stroke={INK} strokeWidth="2.5" /><circle cx="258" cy="165" r="3" fill={p.pale} />
  </g>;
}

function Investor({ p }) {
  return <g>
    <Board x={39} y={31} width={184} height={113} color={p.pale}>
      <path d="M18 17v77h150M23 66l27-24 23 23 27-28 26 31 34-22" stroke={p.main} strokeWidth="4" />
      <path d="M34 91V56m23 35V70m23 21V49m24 42V67m23 24V51m23 40V72" stroke={p.second} strokeWidth="9" opacity=".75" />
    </Board>
    <Paper x={225} y={109} width={49} height={67} angle={5}><path d="m9 52 9-8 9 5 9-18" stroke={p.main} strokeWidth="2.5" /></Paper>
    <path d="M212 178h78" stroke={DARK_WOOD} strokeWidth="7" />
  </g>;
}

function Accountant({ p }) {
  return <g>
    <Desk /><OpenBook x={48} y={79} width={119} color={p.main} />
    <path d="M62 97h32m-32 9h32m-18-16v30m40-24h35m-35 9h35m-20-16v30" stroke="#b6a68b" strokeWidth="1.5" />
    <Calculator x={189} y={54} p={p} angle={6} /><Book x={251} y={113} width={40} color={p.second} angle={-5} />
    <path d="m155 120 20-40" stroke={INK} strokeWidth="4" /><Paper x={66} y={45} width={52} height={29} angle={-8} />
  </g>;
}

function Trader({ p }) {
  return <g>
    <Desk /><Globe x={101} y={78} size={39} p={p} /><Box x={179} y={79} width={67} height={39} color={p.second} /><Box x={218} y={107} width={46} height={44} color={p.main} />
    <Paper x={141} y={87} width={40} height={41} angle={-9} />
    <path d="M164 53c26-19 56-15 73 1m-1-1-2-12m2 12-13-1" stroke={p.main} strokeWidth="3" />
  </g>;
}

function Realtor({ p }) {
  return <g>
    <Desk /><Paper x={176} y={54} width={90} height={74} angle={5}><path d="M12 14h60v46H12zm26 0v46M12 36h25m13 0h22M50 60V36" stroke={p.main} strokeWidth="2.5" /></Paper>
    <path d="M61 86h73v39H61z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="m51 88 46-40 47 40z" fill={p.main} stroke={INK} strokeWidth="3" />
    <path d="M79 99h16v26H79zm28-3h14v13h-14z" fill={PAPER} stroke={INK} strokeWidth="2" /><path d="M117 55V43h11v23" fill={p.second} stroke={INK} strokeWidth="2" />
    <path d="M50 127h104" stroke={DARK_WOOD} strokeWidth="6" /><path d="M147 115h16v15h-16z" fill={p.second} stroke={INK} strokeWidth="2" />
  </g>;
}

function Civil({ p }) {
  return <g>
    <Desk /><path d="M53 54h79v68H53z" fill={p.main} stroke={INK} strokeWidth="2.5" /><path d="M60 64h65v18H60zm0 29h65v20H60z" fill={p.pale} stroke={INK} strokeWidth="1.5" /><path d="M85 72h16m-16 31h16" stroke={INK} strokeWidth="3" />
    <Paper x={149} y={74} width={57} height={54} angle={-4} /><Paper x={160} y={74} width={58} height={53} angle={4} />
    <path d="M232 118v-13c0-9 22-9 22 0v13" fill={p.main} stroke={INK} strokeWidth="2.5" /><path d="M227 113h33v12h-33z" fill={p.second} stroke={INK} strokeWidth="2.5" />
    <rect x="222" y="128" width="47" height="7" rx="3" fill={INK} /><path d="M243 103V84c-12-6-8-23 1-23s13 17 1 23" fill={p.main} stroke={INK} strokeWidth="2.5" />
    <path d="m175 112 8 3 7-3v10l-7 4-8-4z" fill={p.second} opacity=".6" />
  </g>;
}

function Police({ p }) {
  return <g>
    <Desk /><path d="M52 105c0-60 88-60 88 0z" fill={p.main} stroke={INK} strokeWidth="3" /><path d="M46 106h100v12H46z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="M89 60v38m12-38v38" stroke={p.pale} strokeWidth="5" /><path d="M62 122c11 14 45 14 65 0" stroke={INK} strokeWidth="3" />
    <rect x="171" y="55" width="50" height="74" rx="8" fill={p.main} stroke={INK} strokeWidth="3" /><path d="M180 55V28m29 27V39" stroke={INK} strokeWidth="5" /><rect x="179" y="65" width="34" height="18" rx="3" fill={p.pale} stroke={INK} strokeWidth="1.5" /><path d="M181 95h30m-30 8h30m-30 8h30" stroke={INK} strokeWidth="2" /><circle cx="196" cy="120" r="3.5" fill={p.second} />
    <path d="m240 120 10-34 12 3-8 34z" fill={p.second} stroke={INK} strokeWidth="2" /><path d="m250 86 3-10 13 3-4 10" fill={p.pale} stroke={INK} strokeWidth="2" />
  </g>;
}

function Corp({ p }) {
  return <g>
    <Board x={146} y={27} width={126} height={113} color={p.pale}>
      <path d="M14 17h98m-98 30h98m-98 30h98m-64-60v91m34-91v91" stroke="#aaa28c" strokeWidth="1.6" />
      <rect x="20" y="26" width="22" height="13" rx="2" fill={p.main} /><rect x="55" y="56" width="22" height="13" rx="2" fill={p.second} /><rect x="89" y="84" width="20" height="13" rx="2" fill={p.main} />
    </Board>
    <path d="M79 29c-27 29-37 52-23 65m23-65c28 29 37 52 23 65" stroke={p.main} strokeWidth="7" />
    <path d="M74 87h12v15H74z" fill={INK} /><rect x="41" y="101" width="82" height="65" rx="7" fill={PAPER} stroke={INK} strokeWidth="2.5" /><rect x="49" y="109" width="30" height="37" rx="4" fill={p.pale} /><circle cx="64" cy="119" r="7" fill={p.main} /><path d="M54 140c-1-16 21-16 21 0" fill={p.main} /><path d="M88 116h25m-25 11h21m-25 27h39" stroke={p.second} strokeWidth="3" />
  </g>;
}

function Lawyer({ p }) {
  return <g>
    <Desk /><Book x={190} y={108} width={80} color={p.main} angle={2} /><Book x={195} y={92} width={74} color={p.second} angle={-2} /><Book x={198} y={76} width={68} color={p.main} angle={2} />
    <path d="M114 126V39m-26 87h53M65 60h98" stroke={INK} strokeWidth="5" /><circle cx="114" cy="40" r="6" fill={p.warm} stroke={INK} strokeWidth="2" />
    <path d="m77 61-20 37h40zm75 0-20 37h40z" stroke={INK} strokeWidth="2" /><path d="M52 99h50c-2 24-48 24-50 0m75 0h50c-2 24-48 24-50 0" fill={p.warm} stroke={INK} strokeWidth="2.5" />
    <path d="M105 124h19l8 9H97z" fill={p.main} stroke={INK} strokeWidth="2" />
  </g>;
}

function Military({ p }) {
  return <g>
    <Desk /><g transform="translate(46 62) rotate(-5)"><path d="m0 0 39 8 39-8 39 8v58l-39-8-39 8-39-8z" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="M39 8v58M78 0v58" stroke="#a7ac96" strokeWidth="2" /><path d="m9 42 24-12 19 17 18-27 19 20 20-9" stroke={p.main} strokeWidth="4" /><circle cx="69" cy="20" r="5" fill={p.second} /></g>
    <g transform="translate(194 71) rotate(5)"><path d="m5 5 9-17h17l6 19m16-1 7-17h16l10 19" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="m3 6-7 39h42L32 6zm51 0-5 39h43L83 6z" fill={p.main} stroke={INK} strokeWidth="3" /><path d="M30 15h27v18H32z" fill={p.second} stroke={INK} strokeWidth="2" /><ellipse cx="17" cy="45" rx="22" ry="12" fill={p.pale} stroke={INK} strokeWidth="3" /><ellipse cx="70" cy="45" rx="22" ry="12" fill={p.pale} stroke={INK} strokeWidth="3" /><ellipse cx="17" cy="45" rx="14" ry="7" fill={p.main} /><ellipse cx="70" cy="45" rx="14" ry="7" fill={p.main} /></g>
  </g>;
}

function Teacher({ p }) {
  return <g>
    <Board x={40} y={27} width={181} height={120} color={p.main}>
      <path d="M19 24h77m-77 15h103M25 66h24v24H25zm36-9 17 33H48zM119 61h35m-17-17v35" stroke={PAPER} strokeWidth="3" /><path d="M113 105h48" stroke={PAPER} strokeWidth="5" />
    </Board>
    <Book x={196} y={166} width={91} color={p.second} angle={-2} /><Book x={202} y={151} width={85} color={p.main} angle={2} /><Book x={206} y={136} width={77} color={p.pale} angle={-1} />
    <path d="m188 126 73-66" stroke={WOOD} strokeWidth="5" /><path d="m256 64 7-6" stroke={PAPER} strokeWidth="5" />
  </g>;
}

function Researcher({ p }) {
  return <g>
    <Desk /><path d="M60 62v27l-16 27c-4 8 0 11 8 11h39c8 0 12-3 8-11L82 89V62" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="m53 107-5 11c-1 3 1 4 6 4h35c5 0 7-1 5-4l-6-11z" fill={p.second} /><path d="M57 61h28" stroke={INK} strokeWidth="4" /><circle cx="63" cy="114" r="3" fill={PAPER} />
    <path d="M178 123h93m-81-1c-10-39 17-57 37-50" stroke={INK} strokeWidth="8" /><path d="m213 49 24-19 24 29-24 19z" fill={p.main} stroke={INK} strokeWidth="3" /><path d="m231 79 8-7 9 10-8 7z" fill={p.pale} stroke={INK} strokeWidth="2" /><path d="M201 98h46" stroke={INK} strokeWidth="5" /><path d="M213 91h21v7h-21" fill={PAPER} stroke={INK} strokeWidth="2" /><circle cx="207" cy="80" r="9" fill={p.second} stroke={INK} strokeWidth="2.5" />
    <path d="M123 67v43c0 17 22 17 22 0V67" fill={p.pale} stroke={INK} strokeWidth="2.5" /><path d="M126 92v18c0 13 16 13 16 0V92z" fill={p.main} /><path d="M119 64h30m-35 15h42m-37 1v46m31-46v46m-37 0h44" stroke={DARK_WOOD} strokeWidth="3" />
  </g>;
}

function Doctor({ p }) {
  return <g>
    <Desk /><rect x="49" y="63" width="106" height="64" rx="10" fill={p.pale} stroke={INK} strokeWidth="3" /><path d="M76 63V48c0-13 51-13 51 0v15" stroke={INK} strokeWidth="5" /><path d="M50 78h104" stroke={p.main} strokeWidth="3" /><path d="M94 84h17v11h11v17h-11v11H94v-11H83V95h11z" fill={p.second} />
    <path d="M187 47v29c0 26 41 26 41 0V47" stroke={p.main} strokeWidth="6" /><path d="m187 47-6-13m47 13 6-13" stroke={INK} strokeWidth="5" /><path d="M208 97v14c0 24 35 24 35-1" stroke={INK} strokeWidth="4" /><circle cx="243" cy="105" r="12" fill={p.pale} stroke={INK} strokeWidth="3" /><circle cx="243" cy="105" r="5" fill={p.main} />
    <Paper x={254} y={63} width={35} height={61} angle={4}><path d="m6 48 6-9 6 14 7-19" stroke={p.main} strokeWidth="2" /></Paper>
  </g>;
}

function Editor({ p }) {
  return <g>
    <Desk /><Book x={45} y={109} width={68} color={p.main} angle={-2} /><Book x={49} y={93} width={61} color={p.second} angle={2} />
    <Paper x={117} y={45} width={82} height={85} angle={-5}><path d="M7 22h39m-14 9h28m-40 8 6 5 8-11M12 54h52m-47 11 10 7 12-14" stroke={p.second} strokeWidth="2.7" /><path d="M56 13h17v27H56z" stroke={p.main} strokeWidth="2" /></Paper>
    <path d="m210 121 38-71 8 4-39 73-12 6z" fill={p.second} stroke={INK} strokeWidth="2" /><path d="m210 121 7 6-12 6z" fill={PAPER} /><Cup x={272} y={109} color={p.pale} scale={.7} />
  </g>;
}

function Clergy({ p }) {
  return <g>
    <Desk /><OpenBook x={104} y={86} width={123} color={p.main} />
    <path d="M57 127h34m-26-2 8-16 10 16M74 111V75" stroke={DARK_WOOD} strokeWidth="5" /><rect x="64" y="45" width="21" height="39" rx="4" fill={p.warm} stroke={INK} strokeWidth="2" /><path d="M74 46c-18-12-6-24 0-30 7 12 15 21 0 30" fill={p.second} stroke={INK} strokeWidth="1.6" />
    <path d="M239 127h35m-27-2 9-15 9 15m-9-17V84" stroke={DARK_WOOD} strokeWidth="5" /><rect x="247" y="61" width="19" height="28" rx="4" fill={p.warm} stroke={INK} strokeWidth="2" /><path d="M256 62c-13-10-6-18 0-25 6 10 12 17 0 25" fill={p.second} stroke={INK} strokeWidth="1.5" />
    <path d="m153 119 6 16 8-14" fill={p.second} />
  </g>;
}

function Office({ p }) {
  return <g>
    <Desk /><Paper x={83} y={57} width={58} height={70} angle={-5} /><Paper x={115} y={61} width={56} height={66} angle={4} />
    <path d="M195 60h67v65h-67z" fill={p.main} stroke={INK} strokeWidth="2.5" /><path d="M203 70h51v19h-51zm0 27h51v19h-51z" fill={p.pale} stroke={INK} strokeWidth="1.5" /><path d="M221 80h15m-15 27h15" stroke={INK} strokeWidth="3" /><Cup x={58} y={110} color={p.second} scale={.8} />
  </g>;
}

const CAREER_ART = {
  sales: Sales,
  counselor: Counselor,
  pr: Pr,
  hotel: Hotel,
  activist: Activist,
  writer: Writer,
  chef: Chef,
  designer: Designer,
  musician: Musician,
  developer: Developer,
  owner: Owner,
  investor: Investor,
  accountant: Accountant,
  trader: Trader,
  realtor: Realtor,
  civil: Civil,
  police: Police,
  corp: Corp,
  lawyer: Lawyer,
  military: Military,
  teacher: Teacher,
  researcher: Researcher,
  doctor: Doctor,
  editor: Editor,
  clergy: Clergy,
};

/** 직업의 작업 도구만 그린다. 소득·집 소유·수상·자격 취득을 추정하지 않는다. */
export default function CareerObjects({ jobId, level = 1, variant = 0 }) {
  const paletteIndex = Number.isFinite(Number(variant)) ? Math.abs(Math.trunc(Number(variant))) : 0;
  const p = PALETTES[paletteIndex % PALETTES.length];
  const tier = Number.isFinite(Number(level)) ? Math.max(1, Math.min(4, Math.trunc(Number(level)))) : 1;
  const Art = Object.prototype.hasOwnProperty.call(CAREER_ART, jobId) ? CAREER_ART[jobId] : Office;
  return <svg viewBox="0 0 320 210" preserveAspectRatio="xMidYMax meet" className="scene-prop-art" aria-hidden="true" focusable="false" fill="none" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="160" cy="187" rx="137" ry="14" fill="#4d514a" opacity=".09" />
    <ellipse cx="161" cy="185" rx="109" ry="8" fill="#4d514a" opacity=".08" />
    <Art p={p} />
    {tier > 1 && <g transform="translate(11 168)">
      <path d="M0 9h27v8H0z" fill={DARK_WOOD} stroke={INK} strokeWidth="1.3" />
      {Array.from({ length: tier - 1 }, (_, index) => <path key={index} d={`M${index % 2} ${7 - index * 4}h25v4H${index % 2}z`} fill={index % 2 ? p.pale : PAPER} stroke="#b9aa90" strokeWidth="1" />)}
    </g>}
  </svg>;
}
